import { RootState } from "newui/store";

export const selectAppMenuCollapsed = (state: RootState): boolean =>
  state.appMenu.isCollapsed;
